import { dataCheckCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCheckCircle = /*#__PURE__*/createIcon(dataCheckCircle)
export default IconCheckCircle
